/** 
 * The type of commands the popup should display to the user
 * Only used for PopUpNotificationType == TextBased 
 */
export enum PopUpCommandType {
    /** popup should display 'Confirm' button */
    Confirm = 0,
    /** popup should display 'Ok' and 'Cancel' buttons */
    OkCancel = 1
}